import DataTable from 'components/shared/DataTable';
import React, { useEffect, useMemo, useState } from 'react';

import BWButton from 'components/shared/BWButton';
import FilterSearchForm from 'components/shared/FilterSearchForm';
import Modal from 'components/shared/Modal';
import FormSelect from 'components/shared/Select/FormSelect';
import { getListRsError } from 'services/coupon.service';
import { getErrorGroupOptions } from 'services/rs-pro-status.service';

const CouponRsErrorModal = ({ open, value, onChange, onClose }) => {
  const [paramsSearch, setParamsSearch] = useState({});
  const defaultParams = {
    is_active: 1,
    page: 1,
    itemsPerPage: 5,
  };
  const [listErrors, setListErrors] = useState([]);
  const [errorGroupOptions, setErrorGroupOptions] = useState([]);
  const [loading, setLoading] = useState();
  const { items, itemsPerPage, page, totalItems, totalPages } = listErrors;
  const [selected, setSelected] = useState(value || []);

  const loadListRsError = async (newParams) => {
    try {
      setLoading(true);
      const data = await getListRsError({ ...defaultParams, ...newParams });
      setListErrors(data);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadListRsError();
  }, []);

  const loadErrorgroupOptions = async () => {
    try {
      const data = await getErrorGroupOptions();
      let parsedOptions = [];
      if (data) {
        parsedOptions = data.map((item) => ({ label: item?.error_group_name, value: item?.error_group_id }));
      }
      setErrorGroupOptions(parsedOptions);
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    loadErrorgroupOptions();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: 'Mã lỗi máy',
        accessor: 'error_code',
      },
      {
        header: 'Tên lỗi máy',
        accessor: 'error_name',
      },
      {
        header: 'Nhóm lỗi',
        accessor: 'error_group_name',
      },
    ],
    [],
  );

  const handleChangePage = (newPage) => {
    loadListRsError({ page: newPage });
  };

  const handleChangeParamsSearch = (newParams) => {
    setParamsSearch((prevparams) => ({ ...prevparams, ...newParams }));
  };

  const handleResetParamsSearch = () => {
    setParamsSearch({});
    loadListRsError(defaultParams);
  };

  const handleSubmit = () => {
    loadListRsError(paramsSearch);
  };

  return (
    <React.Fragment>
      <Modal
        witdh='50vw'
        header='Chọn lỗi máy'
        open={open}
        onClose={onClose}
        footer={
          <BWButton
            type='success'
            outline
            content='Xác nhận'
            onClick={() => {
              onChange(selected);
              onClose();
            }}
          />
        }>
        <FilterSearchForm
          title='Tìm kiếm'
          onSubmit={handleSubmit}
          onClear={handleResetParamsSearch}
          actions={[
            {
              title: 'Tên lỗi máy',
              component: (
                <input
                  type='text'
                  placeholder='Nhập mã, tên lỗi máy'
                  value={paramsSearch?.search || ''}
                  onChange={(e) => {
                    handleChangeParamsSearch({ search: e.target.value });
                  }}
                  style={{ lineHeight: 1 }}
                />
              ),
            },
            {
              title: 'Nhóm lỗi máy',
              component: (
                <FormSelect
                  bordered={false}
                  allowClear
                  options={errorGroupOptions}
                  value={paramsSearch?.error_group_id}
                  onChange={(newValue) => handleChangeParamsSearch({ error_group_id: newValue })}
                />
              ),
            },
          ]}
        />

        <DataTable
          hiddenActionRow
          hiddenDeleteClick
          fieldCheck='error_id'
          loading={loading}
          columns={columns}
          data={items}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          defaultDataSelect={selected}
          onChangeSelect={setSelected}
          totalItems={totalItems}
          onChangePage={handleChangePage}
        />
      </Modal>
    </React.Fragment>
  );
};

export default CouponRsErrorModal;
